<section id="about">
  <div class="container">
      <div class="row">
          <div class="col-12">
              <h1>Investing for Catholics - On the Road</h1>
          </div>
      </div>
  </div>
</section>

<div class="container my-4">
    Photos shown reflect Investing for Catholics staff participation at various conferences and events. Attendance or sponsorship does not imply endorsement by, or affiliation with, any organization shown.
</div>

<app-photo-album [photos]="photosSMPEP" albumTitle="St Mark's Parish El Paso"></app-photo-album>

<app-photo-album [photos]="photosCCOC50" albumTitle="Catholic Charities of Orange County 50th Anniversary Gala"></app-photo-album>

<app-photo-album [photos]="photosNACPA2026" albumTitle="National Association of Church Personnel Administrators - April 2026"></app-photo-album>

<app-photo-album [photos]="photosDFMC2025" albumTitle="Diocesan Fiscal Management Conference - September 2025"></app-photo-album>

<app-photo-album [photos]="photosCMP2025" albumTitle="Church Management Program - August 2025"></app-photo-album>

